/* -------- B2E Paper Component Text -------- */

const Dec6_Industries_B2B_Cont1_Typo_Text = ['B2E','Business 2 Enterprise','IT Consulting','System Architecture & Design','Programme Management','Technical Delivery Assurance','Security','Data Strategy'];

const Dec6_Industries_B2B_Cont2_Typo_Text = ['B2C','Business 2 Consumer','Software Engineering','Product Innovation','Creative Design','Web Development','Mobile App Development','IT Managed Services'];

const Dec6_Industries_B2B_Cont3_Typo_Text = ['B2G','Business 2 Government','Digital Transformation','AI & ML','Blockchain','Advanced Analytics','Security','Process Excellence'];

export {Dec6_Industries_B2B_Cont1_Typo_Text,Dec6_Industries_B2B_Cont2_Typo_Text,Dec6_Industries_B2B_Cont3_Typo_Text};